// Elude cart helpers on top of Zenith's cart drawer.
// window.EludeCart.add([{ id, quantity }]) → one /cart/add.js request (items array), re-renders and opens the drawer.
(() => {
  if (window.EludeCart) return;
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  const drawer = () => document.querySelector('cart-drawer');

  async function add(items, trigger) {
    const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: SECTIONS, sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || window.EludeStrings?.addError || 'Could not add to bag');
    const d = drawer();
    if (d && typeof d.renderContents === 'function') {
      if (trigger) d.setActiveElement?.(trigger);
      d.renderContents({ id: items[0]?.id, sections: data.sections });
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'elude', cartData: data });
    } else {
      window.location.href = window.routes?.cart_url || '/cart';
    }
    return data;
  }

  window.EludeCart = { add };

  // Product card quick add: open/close the size panel (one open at a time). Esc / outside click closes.
  const closeQa = (qa) => { if (!qa) return; qa.classList.remove('is-open'); qa.querySelector('.e-qa__panel')?.setAttribute('hidden', ''); qa.querySelectorAll('[data-e-qa-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false')); };
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') document.querySelectorAll('.e-qa.is-open').forEach((qa) => { closeQa(qa); qa.querySelector('[data-e-qa-toggle]')?.focus(); }); });
  document.addEventListener('click', (e) => { document.querySelectorAll('.e-qa.is-open').forEach((qa) => { if (!qa.contains(e.target)) closeQa(qa); }); });

  // Upsell rows in the drawer + card quick add (delegated, survives re-render).
  document.addEventListener('click', async (e) => {
    const qaToggle = e.target.closest('[data-e-qa-toggle]');
    if (qaToggle) {
      const qa = qaToggle.closest('.e-qa');
      const open = !qa.classList.contains('is-open');
      document.querySelectorAll('.e-qa.is-open').forEach((o) => o !== qa && closeQa(o));
      if (!open) return closeQa(qa);
      qa.classList.add('is-open');
      qa.querySelector('.e-qa__panel')?.removeAttribute('hidden');
      qa.querySelectorAll('[data-e-qa-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      qa.querySelector('.e-qa__size:not(:disabled)')?.focus({ preventScroll: true });
      return;
    }
    const toggle = e.target.closest('[data-e-upsell-toggle]');
    if (toggle) {
      const sizes = toggle.parentElement.querySelector('.e-ups__sizes');
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      if (sizes) { sizes.hidden = !open; if (open) sizes.querySelector('button:not(:disabled)')?.focus(); }
      return;
    }
    const btn = e.target.closest('[data-e-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try { await add([{ id: Number(btn.dataset.eAdd), quantity: 1 }], btn); closeQa(btn.closest('.e-qa')); }
    catch (err) { const box = document.getElementById('CartDrawer-CartErrors'); if (box) box.textContent = err.message; }
    finally { btn.removeAttribute('aria-busy'); }
  });

  // Card colour swatches: swap the card to the chosen colour in place (photo, name, price, quick add).
  // The dots are plain links, so if the fetch fails the browser just opens that colour's page.
  const cards = new Map();
  const fetchCard = (url) => {
    if (!cards.has(url)) {
      cards.set(url, fetch(url + (url.includes('?') ? '&' : '?') + 'view=elude-card')
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error(r.status))))
        .catch((err) => { cards.delete(url); throw err; }));
    }
    return cards.get(url);
  };
  const prefetch = (e) => {
    const dot = e.target.closest?.('[data-e-sw]:not(.is-active)');
    if (dot) fetchCard(dot.getAttribute('href')).catch(() => {});
  };
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);
  document.addEventListener('click', async (e) => {
    const dot = e.target.closest('[data-e-sw]');
    if (!dot || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    const card = dot.closest('[data-e-card]');
    if (!card || dot.classList.contains('is-active') || card.classList.contains('is-switching')) return;
    const url = dot.getAttribute('href');
    card.classList.add('is-switching');
    try {
      const tpl = document.createElement('template');
      tpl.innerHTML = (await fetchCard(url)).trim();
      const next = tpl.content.querySelector('[data-e-card]');
      if (!next) throw new Error('no card');
      // Keep the image sizing of the grid the card sits in.
      const sizes = card.querySelector('.e-card__img')?.getAttribute('sizes');
      next.querySelectorAll('.e-card__img').forEach((img) => { if (sizes) img.sizes = sizes; img.loading = 'eager'; });
      card.replaceWith(next);
      next.querySelector(`[data-e-sw][href="${url}"]`)?.focus({ preventScroll: true });
    } catch (err) {
      window.location.href = dot.href;
    }
  });
})();
